import { ConflictAccountType } from '@/types/auth';

const GOOGLE_ISSUER = 'https://accounts.google.com';
const APPLE_ISSUER = 'https://appleid.apple.com';

/**
 * Sequence's identity type + issuer (from `onEmailConflict`) as the method to show the user, the
 * same mapping as the mobile app.
 */
export function toConflictAccountType(
  type: string | undefined,
  issuer: string | undefined,
): ConflictAccountType {
  if (type === 'Email') return ConflictAccountType.EMAIL;
  if (type === 'PlayFab') return ConflictAccountType.PLAYFAB;
  if (type === 'OIDC' && issuer === GOOGLE_ISSUER)
    return ConflictAccountType.GOOGLE;
  if (type === 'OIDC' && issuer === APPLE_ISSUER)
    return ConflictAccountType.APPLE;
  return ConflictAccountType.UNKNOWN;
}
